import {Controller} from "@hotwired/stimulus"
import 'ion-rangeslider'

export default class RangeSliderController extends Controller {

    connect() {
        let res = $(this.element)
        let objFrom = res
        let budgetForm = res.closest('#budget_form').find('.budget-value')
        let durationForm = res.closest('#budget_form').find('.duration-value')
        let min = ($(this.element).attr('data-min'))
        let max = ($(this.element).attr('data-max'))
        let from = ($(this.element).attr('data-from'))
        let to = ($(this.element).attr('data-to'))
        let disable = this.element.dataset.disabled == 'true'
        const value2Element = res.closest('.range-slider').find('.value2');
        $(this.element).ionRangeSlider({
            skin: "round",
            type: "double",
            min: min,
            max: max,
            from: from == null ? 0 : from,
            to: to,
            grid: false,
            step: 1,
            force_edges: true,
            disable,
            // to_value: value,
            onFinish: function (data) {
                if (objFrom.length > 0) {
                    objFrom[0].value = `${data.from};${data.to}`
                } else if (res.attr('data-type') == 'budget') {
                    budgetForm[0].value = `${data.from};${data.to}`
                } else if (res.attr('data-type') == 'duration') {
                    durationForm[0].value = `${data.from};${data.to}`
                }
                value2Element.text(`${data.from} - ${data.to} years`);
            }
        });
    }
}